import { Alert, AlertTitle } from "@mui/material";
import FormInput from "../UI/FormInput";
import { InfoIcon } from "components/icon";
import { useTranslation } from "react-i18next";
import i18n from "i18n";

const EmailInput = ({
  alertText = null,
  label = i18n.t("common:email"),
  id = "email",
  helperText = "",
  errorMsg = i18n.t("form:emailInvalid"),
}) => {
  const { t } = useTranslation("form");
  return (
    <>
      <FormInput
        label={label}
        placeholder={t("email")}
        id={id}
        type="email"
        autoComplete={id}
        required={true}
        helperText={helperText}
        errorMsg={[
          { errorMsg, validation: "pattern" },
          {
            errorMsg: i18n.t("form:emailRepeated"),
            validation: "already_exist",
          },
        ]}
      />
      {!!alertText?<Alert
        severity={"info"}
        iconMapping={{
          info: <InfoIcon sx={{ color: "#70737B" }} />,
        }}
        // variant="filled"
        variant="outlined"
        sx={(theme) => ({
          width: "100%",
          border: "1px solid #DBDDE0",
          background: "#ffffff",
          alignItems: "center",
          minWidth: "200px",
          marginTop: -1.5,
          "& .MuiAlertTitle-root": {
            ...theme.typography.caption,
            color: "#475467",
            marginTop: 0,
            marginBottom: 0,
          },
        })}
      >
        <AlertTitle>{alertText}</AlertTitle>
      </Alert>:null}
    </>
  );
};
export default EmailInput;
